const e=async(e,t)=>{let{data:n}=await e.post(`/orgs`,t);return n};export{e as createOrg};
//# sourceMappingURL=create-org.mjs.map